import React from 'react';
import {Field} from 'redux-form';
import SelectField from '../../../../../shared/form-elements/select/field';
import Input from '../../../../../shared/form-elements/input';
import {formatMoney} from '../../../../../shared/format';

const Form = props => (
	<div className="payouts-form__main-fields">
		<div className="affiliates display-flex width-100-p">
			<div className="ui-form__element width-50-p padding-0-5-0-0">
				<Field
					name="affiliate"
					placeholder={props.intl('Affiliate')}
					component={Input}
					multi={false}
					disabled={true}
				/>
			</div>
		</div>
		<div className="affiliates display-flex width-100-p">
			<div className="ui-form__element amount width-50-p padding-0-5-0-0">
				<Field
					name="point_amount"
					placeholder={props.intl('Points amount')}
					normalize={value => formatMoney(value, true)}
					component={Input}
				/>
			</div>
			<div className="ui-form__element amount width-50-p padding-0-5-0-0">
				<Field
					name="amount"
					placeholder={props.intl('Amount')}
					normalize={value => formatMoney(value, true)}
					component={Input}
				/>
			</div>
			<div className="ui-form__element currencies width-50-p">
				<Field
					name="currency"
					placeholder={props.intl('Currency')}
					component={SelectField}
					searchable={false}
					multi={false}
					onChange={currency => props.changeTransactionCurrency(currency[0].value)}
					options={props.selectOptions['currencies']}
				/>
			</div>
		</div>
		<div className="ui-form__element comment">
			<Field name="comment" placeholder={props.intl('Comment')} component={Input} />
		</div>
	</div>
);

export default Form;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/forms/transaction/forms-parts/pointsExchange.js